export default __webpack_public_path__ + "static/proximanova-bold-woff-ceb6c643cb9e8d573a7376be11689785.woff";